<template>
  <el-dialog v-model="showProxy" width="78%" top="5vh" class="modal-container elec-price-modal-wide" :close-on-click-modal="false" append-to-body>
    <!-- >>>>>> 弹窗头部 <<<<<< -->
    <template #header>
      <div class="header-container">
        <span class="title-text" v-if="props.openType == 'add'">{{ $str.getKey('收益管理/创建电价') }}</span>
        <span class="title-text" v-else-if="props.openType == 'reCreate'">{{ $str.getKey('收益管理/复用电价') }}</span>
        <span class="title-text" v-else-if="props.openType == 'edit'">{{ $str.getKey('收益管理/编辑电价') }}</span>
        <!-- <span class="title-text">{{ props.openType == 'add' ? '创建电价' : '编辑电价'}}</span> -->
      </div>
    </template>

    <!-- >>>>>> 弹窗内容 <<<<<< -->
    <template #default>
      <div class="content-container" :class="{ 'spot-mode-content': priceMode === 'spot' }">
        <!-- 电价模式 -->
        <div class="price-mode-section">
          <span class="mode-title">模式选择</span>
          <el-radio-group v-model="priceMode" class="mode-radio-group">
            <el-radio label="proxyPurchase">代理购电电价</el-radio>
            <el-radio label="custom">自定义电价</el-radio>
            <el-radio label="spot">现货电价</el-radio>
            <el-radio label="chargingPile">充电桩电价</el-radio>
          </el-radio-group>
        </div>

        <!-- 电表电价时段 -->
        <div class="meter-info-container" v-if="false">
          <!-- 电表电价时段 -->
          <div class="info-panel-header">
            <div class="header-icon-container">
              <img :src="meterInfoIcon" alt="" class="header-icon">
            </div>
            <div class="header-name">{{ $str.getKey('收益管理/电价时段') }}</div>
            <div class="header-refinfo">
              <el-icon><QuestionFilled /></el-icon>
              <span class="info-text">{{ $str.getKey('收益管理/获取当前电站实际电表的时段') }}</span>
            </div>
          </div>
          <div class="range-table-container">
            <div class="table-content">
              <div class="range-item" v-for="range in meterInfo.rangeList" :key="range">
                <div class="header-cell">{{ range.name }}</div>
                <div class="body-cell"> -- </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 配置面板（现货模式不展示国网参考图，仅展示现货录入区） -->
        <div class="config-info-container" v-if="priceMode !== 'spot'">
          <div class="left-container">
            <div class="info-panel-header">
              <div class="header-name">{{ $str.getKey('收益管理/国网电价') }}</div>
              <div class="header-refinfo" v-if="gwInfoData.isValid">
                <el-icon><QuestionFilled /></el-icon>
                <span class="info-text">{{ $str.getKey('收益管理/当前显示为') }}{{gwInfoData.tipInfo}}{{ $str.getKey('收益管理/图片') }}</span>
              </div>
              <div class="time-selecte-container">
                <el-date-picker v-model="elecPanelData.gwMonth"  type="month" :clearable="false" :editable="false" :placeholder="$str.getKey('收益管理/请选择')" :disabled-date="disabledDate"></el-date-picker>
              </div>
            </div>
            <div class="price-img-container">
              <div class="price-img" v-if="gwInfoData.isValid && gwInfoData.imgUrl">
                <img class="img" v-viewer="{ zIndex: 30000 }" :src="gwInfoData.imgUrl" />
              </div>
              <div class="no-pic" v-else>
                <img :src="noPic" alt="">
                <span class="tip-text">{{ $str.getKey('收益管理/暂无图片') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 非现货：电价信息 + 预览 同一行 -->
        <div class="info-preview-row" v-if="priceMode !== 'spot'">
          <div class="price-info-container">
            <div class="info-panel-header">
              <div class="headesetIntervalr-name">{{ $str.getKey('收益管理/电价信息') }}</div>
              <div class="header-refinfo" v-if="gwInfoData.isValid">
                <el-icon><QuestionFilled /></el-icon>
                <span class="info-text">{{ $str.getKey('收益管理/默认值为') }}{{gwInfoData.tipInfo}}{{ $str.getKey('收益管理/数据') }}</span>
              </div>
            </div>
            <div class="price-form-panel">
            <ElectrovalencePanel
              ref="ElecPanel"
              :presetData="elecPanelData"
              @gwInfoUpdate="handleGwInfoUpdate"
              @previewChange="handlePanelPreviewChange"
            />
            </div>
            <div class="inout-diff-block">
              <div class="inout-diff-row">
                <span class="inout-diff-name">{{ $str.getKey('收益管理/充放电价不一致') }}</span>
                <el-switch v-model="formData.isInOutDiff" class="inout-diff-switch" />
              </div>
              <div class="inout-diff-tip">
                <el-icon><QuestionFilled /></el-icon>
                <span class="info-text">{{ $str.getKey('收益管理/默认关闭，充放电电价不一致时开打操作') }}</span>
              </div>
            </div>
          </div>
          <div class="preview-chart-section">
            <div class="info-panel-header">
              <div class="header-name">电价预览</div>
            </div>
            <div class="preview-chart-body">
              <ElecPriceModalPreview
                ref="modalPreviewRef"
                :chart-kind="previewChartKind"
                :bar-price-info="previewBarPayload"
                :line-values="previewLineValues"
              />
            </div>
          </div>
        </div>

        <!-- 现货：电价表（纵向） + 预览 同一行 -->
        <div class="spot-preview-row" v-if="priceMode === 'spot'">
          <div class="spot-section">
            <div class="info-panel-header">
              <div class="header-name">现货电价</div>
              <div class="header-refinfo">
                <span class="info-text">电价信息即现货表格，按 15 分钟一个点维护日前/实时曲线。</span>
              </div>
            </div>
            <div class="spot-toolbar">
              <el-radio-group v-model="spotActiveType" size="small">
                <el-radio-button label="dayAhead">日前电价</el-radio-button>
                <el-radio-button label="realtime">实时电价</el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="spotDate"
                type="date"
                value-format="YYYY-MM-DD"
                :clearable="false"
                :editable="false"
                placeholder="选择现货日期"
                class="spot-date-picker"
              />
              <div class="spot-actions">
                <el-button size="small" @click="downloadSpotTemplate">下载现货模板</el-button>
                <el-button size="small" type="primary" plain @click="triggerSpotImport">导入文件</el-button>
                <el-button size="small" @click="spotEditMode = !spotEditMode">{{ spotEditMode ? '完成编辑' : '编辑' }}</el-button>
              </div>
              <input
                ref="spotFileInputRef"
                type="file"
                accept=".xls,.xlsx"
                class="hidden-file-input"
                @change="onSpotFileChange"
              />
            </div>
            <div class="spot-table-scroll">
              <table class="spot-grid vertical-grid">
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>时间点</th>
                    <th>{{ spotActiveType === 'dayAhead' ? '日前市场电价(元/MWh)' : '实时市场电价(元/MWh)' }}</th>
                    <th>服务费(元/MWh)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in spotRows" :key="row.index">
                    <td>{{ row.index + 1 }}</td>
                    <td>{{ row.startTime }}</td>
                    <td>
                      <el-input-number
                        v-if="spotEditMode"
                        v-model="spotCurves[spotActiveType][row.index]"
                        :precision="6"
                        :step="0.01"
                        controls-position="right"
                        size="small"
                        class="spot-inum"
                      />
                      <span v-else class="spot-readonly">{{ formatSpotCell(spotCurves[spotActiveType][row.index]) }}</span>
                    </td>
                    <td>
                      <el-input-number
                        v-if="spotEditMode"
                        v-model="spotServiceFees[spotActiveType][row.index]"
                        :min="0"
                        :precision="6"
                        :step="0.01"
                        controls-position="right"
                        size="small"
                        class="spot-inum"
                      />
                      <span v-else class="spot-readonly">{{ formatSpotCell(spotServiceFees[spotActiveType][row.index]) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="preview-chart-section">
            <div class="info-panel-header">
              <div class="header-name">电价预览</div>
            </div>
            <div class="preview-chart-body">
              <ElecPriceModalPreview
                ref="modalPreviewRef"
                :chart-kind="previewChartKind"
                :bar-price-info="previewBarPayload"
                :line-values="previewLineValues"
              />
            </div>
          </div>
        </div>

      </div>
    </template>

    <!-- >>>>>> 弹窗底部 <<<<<< -->
    <template #footer>
      <div class="footer-container">
        <el-button @click="handleClose()" class="cancel-btn">{{ $str.getKey('收益管理/取消') }}</el-button>
        <el-button type="primary" @click="onConfirm" class="confirm-btn" :disabled="isConfirming">{{ $str.getKey('收益管理/确定') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import { defineEmits, defineOptions, defineProps, reactive, ref, nextTick, watch, computed, watchEffect, inject } from "vue";
import { useVModel } from "@vueuse/core";
import { ElMessageBox } from 'element-plus'
import dayjs from 'dayjs';
import useAppStore from "@/store/modules/app";
import { createElecPrice, editElecPrice, queryElecPriceInfoById, queryElecPriceInUse, queryDateRangeIsOverlap, querySpotSnapshotByArea, batchSaveSpotSnapshot, queryProvinceCity, downloadSpotSnapshotTemplate, importSpotSnapshot, queryEnergyPriceByStation, createEnergyPrice, updateEnergyPrice } from "./api/index.js";
import ElectrovalencePanel from "./electrovalencePanel.vue"
import ElecPriceModalPreview from "./elecPriceModalPreview.vue"
import { getElecPriceSegmentName } from "@/utils/nameHelper/index.js"
import { getElecPriceSegmentColor } from "@/utils/colorHelper/index.js"
import { getMinutesCountByTime, getTimeByMinutesCount } from "@/utils/timeHelper/index.js"

const $str = window.$str;

const trackEvent = inject('trackEvent', () => {}); 
const trackEventTypes = inject('trackEventTypes', {
  create: 'create',
  edit: 'edit',
  otherOperate: 'otherOperate'
});
const trackDatas = reactive({
  commitCreate: {
    targetId: '',
    refData: {
      targetName: '新增电价弹窗/确定按钮',
      desc: '点击按钮，提交创建电价的相关信息'
    },
  },
  commitEdit: {
    targetId: '',
    refData: {
      targetName: '编辑电价弹窗/确定按钮',
      desc: '点击按钮，提交编辑电价的相关信息'
    },
  },
})
const stationBaseDataRef = inject('stationBaseData', computed(() => ({})))

const meterInfoIcon = new URL('./assets/icon00.svg', import.meta.url).href;
const unitivePriceIcon = new URL('./assets/icon01.svg', import.meta.url).href;
const cfgIcon = new URL('./assets/icon02.svg', import.meta.url).href;
const priceInfoIcon = new URL('./assets/icon03.svg', import.meta.url).href;
const noPic = new URL('@/assets/noPic.svg', import.meta.url).href;
 

const appStore = useAppStore()
const stationId = computed(() => appStore.stationId)

/** 设置组件配置项 */
defineOptions({
  name: "AddAndEditModal"
});

/** 接收父组件信息 */
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  openType: {
    type: String,
    default: ''
  },
  elecPriceId: {
    type: [String, Number], // 允许的类型为 String 或 Number
    default: ''
  }
});

const emit = defineEmits(['update:show', 'onClose']);
const showProxy = useVModel(props, "show", emit);
const isConfirming = ref(false); // 防抖【连续多次点击提交按钮】
const ElecPanel = ref(null); // 引用子组件：ElectrovalencePanel
const modalPreviewRef = ref(null)
const spotFileInputRef = ref(null)

/** 电价录入模式：代理购电 | 自定义 | 现货 | 充电桩（充电桩与自定义共用表单逻辑） */
const priceMode = ref('proxyPurchase')
const spotActiveType = ref('dayAhead')
const spotEditMode = ref(false)
const spotDate = ref(dayjs().format('YYYY-MM-DD'))
/** 未导入时的默认骨架：15 分钟一档，时点用「区间起点」口径 00:00 ~ 23:45 */
const SPOT_DEFAULT_INTERVAL = 15
const makeDefaultSpotSlots = () =>
  Array.from({ length: (24 * 60) / SPOT_DEFAULT_INTERVAL }, (_, i) =>
    getTimeByMinutesCount(i * SPOT_DEFAULT_INTERVAL)
  )
const makeZeros = (length) => Array.from({ length }, () => 0)

/**
 * 现货时间点，是表格行数与曲线长度的唯一来源
 * 未导入时为默认 15 分钟骨架，导入后完全按接口返回的时间点展示（间隔可以是任意值）
 */
const spotSlots = reactive({
  dayAhead: makeDefaultSpotSlots(),
  realtime: makeDefaultSpotSlots(),
})
const spotCurves = reactive({
  dayAhead: makeZeros(spotSlots.dayAhead.length),
  realtime: makeZeros(spotSlots.realtime.length),
})
const spotServiceFees = reactive({
  dayAhead: makeZeros(spotSlots.dayAhead.length),
  realtime: makeZeros(spotSlots.realtime.length),
})
const spotRows = computed(() => {
  const slots = spotSlots[spotActiveType.value] || []
  return slots.map((startTime, index) => ({ index, startTime }))
})

const previewBarPayload = ref({ priceDetails: [], chargeType: 2 })
const previewLineValues = ref([])
const panelPreviewPayload = ref(null)
const gwTimelineDetails = ref([])
const provinceCityOptions = ref([])
const spotAreaWarned = ref(false)
const chargingPileCurrentId = ref(null)



// 电表信息：电价时段
const meterInfo = reactive({
  rangeList: [
    {
      key: 'shrap',
      name: $str.getKey('收益管理/尖峰时段'),
      ranges: [], // {st, et},{st, et},
    },
    {
      key: 'peak',
      name: $str.getKey('收益管理/高峰时段'),
      ranges: [],
    },
    {
      key: 'flat',
      name: $str.getKey('收益管理/平时段'),
      ranges: [],
    },
    {
      key: 'valley',
      name: $str.getKey('收益管理/低谷时段'),
      ranges: [],
    },
    {
      key: 'deepValley',
      name: $str.getKey('收益管理/深谷时段'),
      ranges: [],
    },
  ]
})

const previewChartKind = computed(() => (priceMode.value === 'spot' ? 'line' : 'bar'))


// 表单信息
const formData = reactive({
  isUseGwPrice: true, // 是否使用国网电价
  isInOutDiff: false, // 是否充放电价一致
  isCustomDefine: false, // 是否按电能值估算
})

// 国网电价信息
const gwInfoData = reactive({
  isValid: false,
  imgUrl: '',
  tipInfo: '',
})


// 传递给 ElectrovalencePanel 组件的数据
const elecPanelData = reactive({
  editType: props.openType,
  operateType: '',
  originInfo: null,
  gwMonth: dayjs().format('YYYY-MM'), // 参考的国网电价信息对应的月份
  hidePriceTable: false,
})



/** ====== [业务：功能方法] =================================================================== */

/** 顶部模式驱动原「国网 / 自定义」开关 */
watch(
  () => priceMode.value,
  (m) => {
    if (m === 'proxyPurchase') {
      formData.isUseGwPrice = true
      formData.isCustomDefine = false
    } else if (m === 'custom') {
      formData.isUseGwPrice = false
      formData.isCustomDefine = true
    } else if (m === 'chargingPile') {
      // 充电桩电价使用“固定五段电价”结构，便于对接 v3 能源电价接口字段
      formData.isUseGwPrice = true
      formData.isCustomDefine = false
      loadChargingPilePrice()
    } else {
      // spot 等模式
      formData.isUseGwPrice = false
      formData.isCustomDefine = true
    }
    if (m === 'spot') {
      formData.isInOutDiff = false
    }
    if (showProxy.value) updateModalPreview()
  },
  { immediate: true }
)

watchEffect(() => {
  elecPanelData.hidePriceTable = priceMode.value === 'spot'
})

watch(
  () => spotActiveType.value,
  () => {
    if (showProxy.value && priceMode.value === 'spot') {
      updateModalPreview()
    }
  }
)

watch(
  () => spotCurves[spotActiveType.value],
  () => {
    if (showProxy.value && priceMode.value === 'spot') {
      updateModalPreview()
    }
  },
  { deep: true }
)
watch(
  () => spotServiceFees[spotActiveType.value],
  () => {
    if (showProxy.value && priceMode.value === 'spot') {
      updateModalPreview()
    }
  },
  { deep: true }
)

watch(
  () => [showProxy.value, priceMode.value, spotDate.value, spotActiveType.value, stationId.value],
  ([show, mode, date]) => {
    if (!show || mode !== 'spot' || !date) return
    loadSpotSnapshotData()
  }
)

watchEffect(() => {
  if (formData.isUseGwPrice && !formData.isInOutDiff && !formData.isCustomDefine) {
    elecPanelData.operateType = 'GW_SAME';
  } else if (formData.isUseGwPrice && formData.isInOutDiff && !formData.isCustomDefine) {
    elecPanelData.operateType = 'GW_DIFF';
  } else if (formData.isCustomDefine && !formData.isInOutDiff) {
    elecPanelData.operateType = 'CUSTOM_SAME'; // 充放电电价一致
  } else if (formData.isCustomDefine && formData.isInOutDiff) {
    elecPanelData.operateType = 'CUSTOM_DIFF'; // 充放电电价不同
  } else {
    elecPanelData.operateType = 'GW_SAME';
  }

})

watch(
  () => [showProxy.value, props.elecPriceId, props.openType],
  () => {
    if (!showProxy.value) return
    elecPanelData.editType = props.openType
    if (props.openType === 'add' && !props.elecPriceId) {
      resetModalForCreate()
    } else if (props.elecPriceId) {
      loadElecPriceRecord(props.elecPriceId)
    }
    nextTick(() => updateModalPreview())
  },
  { immediate: true }
)

/** 设置日期的禁选范围 */
function disabledDate(date) {
  return date < dayjs().subtract(6, 'month').startOf('month');
  // return date > dayjs() || date < dayjs().subtract(6, 'month').startOf('month');
}


/** 事件响应：子组件通知的国网电价信息已更新 */
function handleGwInfoUpdate(info) {
  if (info.imgUrl || info.tipInfo) {
    gwInfoData.imgUrl = info.imgUrl;
    gwInfoData.tipInfo = info.tipInfo;
    gwInfoData.isValid = true;
  } else {
    gwInfoData.isValid = false;
    gwInfoData.imgUrl = '';
    gwInfoData.tipInfo = '';
  }
}

function handlePanelPreviewChange(payload) {
  panelPreviewPayload.value = payload
  if (priceMode.value !== 'spot') {
    updateModalPreview()
  }
}


/** 关闭面板 */
function handleClose(needRefresh = false) {
  // 关闭弹窗
  showProxy.value = false;
  // 通知父组件关闭当前弹窗。 参数: 父组件是否需要刷新数据。 
  emit("onClose", needRefresh);
}


/** 提交表单 */
async function onConfirm() {
  // 格式化提交接口需要的参数
  const params = {
    stationId: stationId.value,
    // startDate: 
    // startDate: 
    // endDate: 
    stateGridPrice: formData.isUseGwPrice, // 是否按国网电价
    immediate: true,
    energyPrice: formData.isCustomDefine, // 是否按电能估算【自定义时段电价】
    remark: '', // 备注
    // basePrice: {}, // 基础电价数据
    // customPrice: {}, // 自定义电价
  }

  // 数据校验
  let isOK = true;

  // 获取电价表单信息（现货模式下表单组件不渲染，改用现货日期兜底）
  const priceForm = priceMode.value === 'spot'
    ? {
        dateRange: spotDate.value ? [spotDate.value, spotDate.value] : [],
        priceName: '',
        operateType: '',
        tableData: [],
        demandPrice: 0,
      }
    : ElecPanel.value?.getCommitData?.();
  if (!priceForm) {
    window.dispatchNotify({
      type: "warning",
      message: '电价表单未初始化，请重新打开弹框后重试。'
    });
    return false;
  }
  const demandPrice = +priceForm?.demandPrice
  const isDemandPriceValid = Number.isFinite(demandPrice) && demandPrice >= 0

  // 校验：时间范围
  isOK = checkDateRange(params, priceForm?.dateRange);
  if (!isOK) {
    window.dispatchNotify({
      type: "warning",
      message: $str.getKey('收益管理/请选择正确的时间范围！')
    });
    return isOK;
  }

  // 校验：电价数据（现货走时间点曲线，其它走原表单）
  if (priceMode.value === 'spot') {
    isOK = checkSpotPriceData()
    if (!isOK) return isOK
    isConfirming.value = true
    isOK = await saveSpotSnapshotData()
    isConfirming.value = false
    if (!isOK) return isOK
    window.dispatchNotify({
      type: "success",
      message: props.openType === 'edit' ? $str.getKey('收益管理/修改成功！') : $str.getKey('收益管理/创建成功！')
    });
    handleClose(true)
    return true
  } else {
    if (!isDemandPriceValid) {
      window.dispatchNotify({
        type: "warning",
        message: '请正确输入需量电价！'
      });
      return false;
    }
    isOK = checkPriceListData(params, priceForm.operateType, priceForm.tableData, demandPrice);
    if (!isOK) {
      nextTick(() => {
        window.dispatchNotify({
          type: "warning",
          message: $str.getKey('收益管理/请正确输入电价！')
        });
      })
      return isOK;
    }
  }

  // 校验：时段名称
  if (priceMode.value !== 'spot') {
    isOK = checkSigmentName(priceForm.operateType, priceForm.tableData);
    if (!isOK) {
      nextTick(() => {
        window.dispatchNotify({
          type: "warning",
          message: $str.getKey('收益管理/时段名称不能为空！')
        });
      })
      return isOK;
    }
  }

  // 校验：电价名称（现货模式已自动赋默认名称）
  if (priceMode.value !== 'spot') {
    isOK = await checkElecPriceName(params, priceForm?.priceName);
    if (!isOK) {
      window.dispatchNotify({
        type: "warning",
        message: $str.getKey('收益管理/请输入电价名称！')
      });
      return isOK;
    }
  }


  // 校验：时间重叠
  if (priceMode.value !== 'spot' && priceMode.value !== 'chargingPile') {
    isOK = await checkExistOverlap(priceForm.dateRange, props.openType, props.elecPriceId);
    if (!isOK) {
      nextTick(() => {
        window.dispatchNotify({
          type: "warning",
          message: $str.getKey('收益管理/请修改日期范围！ ')
        });
      })

      return isOK;
    }
  }

  params.remark = buildRemarkForSubmit()

  if (priceMode.value === 'chargingPile') {
    isConfirming.value = true
    const payload = buildChargingPilePayload(priceForm)
    if (props.openType === 'edit' || chargingPileCurrentId.value) {
      payload.id = chargingPileCurrentId.value || props.elecPriceId
    }
    const req = payload.id ? updateEnergyPrice(payload) : createEnergyPrice(payload)
    req.then(() => {
      window.dispatchNotify({
        type: "success",
        message: props.openType === 'edit' || chargingPileCurrentId.value ? $str.getKey('收益管理/修改成功！') : $str.getKey('收益管理/创建成功！')
      });
      handleClose(true)
    }).catch((err) => {
      console.error('接口异常：', err);
    }).finally(() => {
      isConfirming.value = false
    })
    return
  }

  isConfirming.value = true;
  if (props.openType == 'edit') {
    // 调用API-提交编辑
    params['id'] = props.elecPriceId;
    // 调用API-执行编辑
    editElecPrice(params).then(res => {
      // 埋点：
      trackDatas.commitEdit.refData['stationId'] = stationId.value;
      trackDatas.commitEdit.refData['elecPriceId'] = props.elecPriceId;
      trackEvent(trackEventTypes.edit, trackDatas.commitEdit);

      // 提示用户：操作成功
      window.dispatchNotify({
        type: "success",
        message: $str.getKey('收益管理/修改成功！')
      });
      handleClose(true); // 关闭弹窗&刷新父组件页面数据
    }).catch(err => {
      console.error('接口异常：',err);
    }).finally(() => {
      isConfirming.value = false;
    });

  } else {
    // 调用API-执行创建
    createElecPrice(params).then(res => {
      // 埋点：
      trackDatas.commitCreate.refData['stationId'] = stationId.value;
      trackEvent(trackEventTypes.create, trackDatas.commitCreate);

      // 提示用户：操作成功
      window.dispatchNotify({
        type: "success",
        message: $str.getKey('收益管理/创建成功！')
      });
      handleClose(true); // 关闭弹窗&刷新父组件页面数据
    }).catch(err => {
      console.error('接口异常：',err);
    }).finally(() => {
      isConfirming.value = false;
    });
  }

}



/** ====== [辅助：功能方法] =================================================================== */

function formatSpotCell(v) {
  if (v === null || v === undefined || v === '') return '—'
  const n = +v
  return Number.isFinite(n) ? n.toFixed(4) : '—'
}

function resetSpotCurves() {
  spotSlots.dayAhead = makeDefaultSpotSlots()
  spotSlots.realtime = makeDefaultSpotSlots()
  spotCurves.dayAhead = makeZeros(spotSlots.dayAhead.length)
  spotCurves.realtime = makeZeros(spotSlots.realtime.length)
  spotServiceFees.dayAhead = makeZeros(spotSlots.dayAhead.length)
  spotServiceFees.realtime = makeZeros(spotSlots.realtime.length)
}

function resetModalForCreate() {
  priceMode.value = 'proxyPurchase'
  formData.isUseGwPrice = true
  formData.isCustomDefine = false
  formData.isInOutDiff = false
  spotActiveType.value = 'dayAhead'
  spotEditMode.value = false
  spotDate.value = dayjs().format('YYYY-MM-DD')
  resetSpotCurves()
  elecPanelData.originInfo = null
  gwTimelineDetails.value = []
  chargingPileCurrentId.value = null
  elecPanelData.gwMonth = dayjs().format('YYYY-MM')
  // 新增态同样读取外部卡片同源时段，避免预览按等分回退
  loadGwTimelineFromInUseList()
}

function parseRemarkMeta(remark) {
  if (!remark || typeof remark !== 'string' || remark === 'spot') return null
  try {
    const j = JSON.parse(remark)
    if (j && typeof j === 'object') return j
  } catch (e) {}
  return null
}

/**
 * 编辑已保存记录时恢复现货数据
 *
 * remark 里的 meta 只有价格数组、没有时间点，因此按其长度还原等分骨架；
 * 真正的时间点以 loadSpotSnapshotData() 拉回的快照为准（随后会覆盖这里的结果）
 */
function hydrateSpotFromRecord(data) {
  resetSpotCurves()
  const meta = parseRemarkMeta(data.remark)
  if (meta?.spot?.date) {
    spotDate.value = meta.spot.date
  }

  const restore = (target, key, values) => {
    if (!Array.isArray(values) || !values.length) return
    if (1440 % values.length !== 0) return
    const step = 1440 / values.length
    spotSlots[key] = values.map((_, i) => getTimeByMinutesCount(i * step))
    target[key] = values.map((v) => +v || 0)
  }

  restore(spotCurves, 'dayAhead', meta?.spot?.dayAhead)
  restore(spotCurves, 'realtime', meta?.spot?.realtime)
  if (meta?.spot?.serviceDayAhead?.length === spotCurves.dayAhead.length) {
    spotServiceFees.dayAhead = meta.spot.serviceDayAhead.map((v) => +v || 0)
  }
  if (meta?.spot?.serviceRealtime?.length === spotCurves.realtime.length) {
    spotServiceFees.realtime = meta.spot.serviceRealtime.map((v) => +v || 0)
  }

  if (Array.isArray(data.priceDetails) && data.priceDetails.length) {
    const vals = data.priceDetails.map((it) => +it.chargePrice || 0)
    if (!meta?.spot?.dayAhead?.length) restore(spotCurves, 'dayAhead', vals)
    if (!meta?.spot?.realtime?.length) restore(spotCurves, 'realtime', vals)
  }

  // 曲线长度变化后，服务费数组要跟着对齐，否则校验会判定数据异常
  if (spotServiceFees.dayAhead.length !== spotCurves.dayAhead.length) {
    spotServiceFees.dayAhead = makeZeros(spotCurves.dayAhead.length)
  }
  if (spotServiceFees.realtime.length !== spotCurves.realtime.length) {
    spotServiceFees.realtime = makeZeros(spotCurves.realtime.length)
  }
}

function inferPriceModeFromRecord(data) {
  const isGw = data.type === 1
  if (isGw) return 'proxyPurchase'
  if (data.remark === 'spot') return 'spot'
  const meta = parseRemarkMeta(data.remark)
  if (meta?.entryMode === 'spot') return 'spot'
  if (meta?.entryMode === 'chargingPile') return 'chargingPile'
  return 'custom'
}

/** 加载编辑 / 复用记录 */
function loadElecPriceRecord(elecPriceId) {
  if (!elecPriceId) return
  queryElecPriceInfoById(elecPriceId)
    .then((res) => {
      if (res?.data) {
        const d = res.data
        formData.isUseGwPrice = d.type === 1
        formData.isInOutDiff = d.chargeType === 2 ? false : true
        elecPanelData.originInfo = d
        const mode = inferPriceModeFromRecord(d)
        priceMode.value = mode
        // 编辑态优先使用和外部卡片同源的数据，保证时段预览一致
        loadGwTimelineFromInUseList(elecPriceId)
        if (mode === 'spot') {
          hydrateSpotFromRecord(d)
        }
      }
    })
    .catch(() => {})
}

function pickTimelineSourceFromInUseList(list, elecPriceId) {
  const items = Array.isArray(list) ? list : []
  if (!items.length) return null

  if (elecPriceId) {
    const matchedById = items.find((it) => String(it?.id) === String(elecPriceId) && Array.isArray(it?.priceDetails) && it.priceDetails.length)
    if (matchedById) return matchedById
  }

  const now = dayjs()
  const activeNow = items.find((it) => {
    if (!Array.isArray(it?.priceDetails) || !it.priceDetails.length) return false
    if (!it?.startDate || !it?.endDate) return false
    return !now.isBefore(dayjs(it.startDate), 'day') && !now.isAfter(dayjs(it.endDate), 'day')
  })
  if (activeNow) return activeNow

  return items.find((it) => Array.isArray(it?.priceDetails) && it.priceDetails.length) || null
}

function loadGwTimelineFromInUseList(elecPriceId = '') {
  gwTimelineDetails.value = []
  queryElecPriceInUse(stationId.value)
    .then((res) => {
      const list = Array.isArray(res?.data) ? res.data : []
      const source = pickTimelineSourceFromInUseList(list, elecPriceId)
      if (Array.isArray(source?.priceDetails) && source.priceDetails.length) {
        gwTimelineDetails.value = source.priceDetails
        if (showProxy.value) updateModalPreview()
      }
    })
    .catch(() => {})
}

function firstValidEnergyPrice(list) {
  const arr = Array.isArray(list) ? list : []
  if (!arr.length) return null
  const usingItem = arr.find((it) => Number(it?.status) === 1)
  return usingItem || arr[0]
}

function applyChargingPileToPanel(record) {
  if (!record || typeof record !== 'object') return
  chargingPileCurrentId.value = record.id ?? null
  const mapped = {
    id: record.id,
    stationId: record.stationId ?? stationId.value,
    type: 1,
    chargeType: formData.isInOutDiff ? 0 : 2,
    priceName: record.priceName || '',
    startDate: record.startDate || dayjs().format('YYYY-MM-DD'),
    endDate: record.endDate || dayjs().format('YYYY-MM-DD'),
    demandPrice: Number(record.demandPrice ?? 0),
    priceDetails: [
      { name: 'sharp', chargePrice: Number(record.inSharpPrice ?? 0), dischargePrice: Number(record.outSharpPrice ?? record.inSharpPrice ?? 0) },
      { name: 'peak', chargePrice: Number(record.inPeakPrice ?? 0), dischargePrice: Number(record.outPeakPrice ?? record.inPeakPrice ?? 0) },
      { name: 'flat', chargePrice: Number(record.inFlatPrice ?? 0), dischargePrice: Number(record.outFlatPrice ?? record.inFlatPrice ?? 0) },
      { name: 'valley', chargePrice: Number(record.inValleyPrice ?? 0), dischargePrice: Number(record.outValleyPrice ?? record.inValleyPrice ?? 0) },
      { name: 'deepValley', chargePrice: Number(record.inDeepValleyPrice ?? 0), dischargePrice: Number(record.outDeepValleyPrice ?? record.inDeepValleyPrice ?? 0) },
    ],
  }
  formData.isInOutDiff = mapped.chargeType !== 2
  elecPanelData.originInfo = mapped
}

async function loadChargingPilePrice() {
  if (!stationId.value) return
  try {
    const res = await queryEnergyPriceByStation(stationId.value, 2)
    const target = firstValidEnergyPrice(res?.data)
    if (target) {
      applyChargingPileToPanel(target)
      nextTick(() => updateModalPreview())
    }
  } catch (e) {}
}

function buildChargingPilePayload(priceForm) {
  const demandPrice = Number((+priceForm?.demandPrice || 0).toFixed(6))
  const payload = {
    stationId: Number(stationId.value),
    type: 2,
    priceName: paramsPriceNameForChargingPile(priceForm),
    startDate: dayjs(priceForm?.dateRange?.[0]).format('YYYY-MM-DD'),
    endDate: dayjs(priceForm?.dateRange?.[1]).format('YYYY-MM-DD'),
    demandPrice,
    capacityPrice: 0,
    status: 0,
    inSharpPrice: 0, inPeakPrice: 0, inFlatPrice: 0, inValleyPrice: 0, inDeepValleyPrice: 0,
    outSharpPrice: 0, outPeakPrice: 0, outFlatPrice: 0, outValleyPrice: 0, outDeepValleyPrice: 0,
  }
  if (priceForm?.operateType === 'GW_SAME' && Array.isArray(priceForm?.tableData)) {
    priceForm.tableData.forEach((it) => {
      const k = String(it.key || '')
      const v = Number((+it.value || 0).toFixed(6))
      if (k === 'sharpPrice') payload.inSharpPrice = payload.outSharpPrice = v
      if (k === 'peakPrice') payload.inPeakPrice = payload.outPeakPrice = v
      if (k === 'flatPrice') payload.inFlatPrice = payload.outFlatPrice = v
      if (k === 'valleyPrice') payload.inValleyPrice = payload.outValleyPrice = v
      if (k === 'deepValleyPrice') payload.inDeepValleyPrice = payload.outDeepValleyPrice = v
    })
  } else if (priceForm?.operateType === 'GW_DIFF' && priceForm?.tableData) {
    ;(priceForm.tableData.in || []).forEach((it) => {
      const v = Number((+it.value || 0).toFixed(6))
      payload[it.key] = v
    })
    ;(priceForm.tableData.out || []).forEach((it) => {
      const v = Number((+it.value || 0).toFixed(6))
      payload[it.key] = v
    })
  }
  return payload
}

function paramsPriceNameForChargingPile(priceForm) {
  const raw = String(priceForm?.priceName || '').trim()
  if (raw) return raw
  return `充电桩电价-${dayjs().format('YYYY-MM-DD')}`
}

function triggerSpotImport() {
  spotFileInputRef.value && spotFileInputRef.value.click()
}

async function downloadSpotTemplate() {
  try {
    const blobData = await downloadSpotSnapshotTemplate()
    const blob = blobData instanceof Blob ? blobData : new Blob([blobData], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = '现货电价导入模板.xlsx'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (e) {
    window.dispatchNotify({ type: 'warning', message: '模板下载失败，请稍后重试。' })
  }
}

function normalizeProvinceName(name) {
  return String(name || '')
    .trim()
    .replace(/(省|市|壮族自治区|回族自治区|维吾尔自治区|自治区|特别行政区)$/g, '')
}

async function ensureProvinceCityOptions() {
  if (provinceCityOptions.value.length) return provinceCityOptions.value
  const res = await queryProvinceCity()
  provinceCityOptions.value = Array.isArray(res?.data) ? res.data : []
  return provinceCityOptions.value
}

function resolveSpotAreaCodeFromStation() {
  const base = stationBaseDataRef?.value || {}
  const station = appStore.currentStation || {}
  return String(
    base.areaCode
    ?? base.adCode
    ?? base.provinceCode
    ?? station.areaCode
    ?? station.adCode
    ?? station.provinceCode
    ?? station.provinceId
    ?? ''
  ).trim()
}

function resolveSpotAreaName() {
  const base = stationBaseDataRef?.value || {}
  const station = appStore.currentStation || {}
  return String(base.areaName ?? base.province ?? station.areaName ?? station.province ?? '').trim()
}

async function resolveSpotAreaCode() {
  const direct = resolveSpotAreaCodeFromStation()
  if (direct) return direct
  const base = stationBaseDataRef?.value || {}
  const station = appStore.currentStation || {}
  const stationProvince = normalizeProvinceName(base.province || base.areaName || station.province || station.areaName || '')
  if (!stationProvince) return ''
  const list = await ensureProvinceCityOptions()
  const matched = list.find((it) => normalizeProvinceName(it?.name) === stationProvince)
  return String(matched?.code || '').trim()
}

function toSpotApiPriceType() {
  return spotActiveType.value === 'dayAhead' ? '2' : '1'
}

/**
 * 用接口返回的现货数据重建当前类型的时间点与曲线
 *
 * 时间点完全以接口为准：导入 24 点就显示 24 行、96 点就显示 96 行，不再套死
 * 15 分钟 96 点骨架（那会让非 15 分钟间隔的导入数据整行匹配不上而静默丢弃）。
 * 接口无数据时回落到默认骨架，保证「未导入时可编辑 00:00~23:45」。
 *
 * 24:00 是下一天的起点，不属于当天，过滤掉以避免多出一行。
 */
function fillSpotFromSnapshot(list) {
  const key = spotActiveType.value
  const rows = (Array.isArray(list) ? list : [])
    .map((it) => ({ slot: normalizeClockTime(it.timeSlot), raw: it }))
    .filter((it) => it.slot && it.slot !== '24:00')
    .sort((a, b) => getMinutesCountByTime(a.slot) - getMinutesCountByTime(b.slot))

  if (!rows.length) {
    spotSlots[key] = makeDefaultSpotSlots()
    spotCurves[key] = makeZeros(spotSlots[key].length)
    spotServiceFees[key] = makeZeros(spotSlots[key].length)
    return
  }

  spotSlots[key] = rows.map((it) => it.slot)
  spotCurves[key] = rows.map((it) => +it.raw.marketPrice || 0)
  spotServiceFees[key] = rows.map((it) => +it.raw.servicePrice || 0)
}

async function loadSpotSnapshotData() {
  const areaCode = await resolveSpotAreaCode()
  if (!areaCode || !spotDate.value || !stationId.value) {
    if (!areaCode && !spotAreaWarned.value && showProxy.value && priceMode.value === 'spot') {
      spotAreaWarned.value = true
      window.dispatchNotify({ type: 'warning', message: '未获取到电站省份行政区划编码，无法拉取现货数据。' })
    }
    return
  }
  spotAreaWarned.value = false
  try {
    const res = await querySpotSnapshotByArea({
      areaCode,
      priceDate: spotDate.value,
      priceType: toSpotApiPriceType(),
      stationId: String(stationId.value),
    })
    const list = Array.isArray(res?.data) ? res.data : []
    const sid = String(stationId.value)
    const stationLevel = list.filter((it) => String(it?.stationId) === sid)
    const provinceLevel = list.filter((it) => String(it?.stationId) === '0')
    const preferred = stationLevel.length ? stationLevel : provinceLevel
    fillSpotFromSnapshot(preferred)
    if (showProxy.value && priceMode.value === 'spot') updateModalPreview()
  } catch (e) {}
}

async function onSpotFileChange(ev) {
  const file = ev.target.files?.[0]
  if (!file) return
  const fileName = String(file.name || '').toLowerCase()
  if (!fileName.endsWith('.xls') && !fileName.endsWith('.xlsx')) {
    window.dispatchNotify({ type: 'warning', message: '请上传 .xls 或 .xlsx 文件。' })
    ev.target.value = ''
    return
  }
  try {
    const areaCode = await resolveSpotAreaCode()
    const res = await importSpotSnapshot(file, {
      areaCode,
      areaName: resolveSpotAreaName(),
      priceType: Number(toSpotApiPriceType()),
      stationId: stationId.value,
    })
    window.dispatchNotify({ type: 'success', message: res?.msg || '导入成功。' })
    loadSpotSnapshotData()
  } catch (e) {} finally {
    ev.target.value = ''
  }
}

function normalizeGwSegmentKey(rawKey) {
  if (!rawKey) return ''
  let key = String(rawKey).trim()
  if (!key) return ''
  const lower = key.toLowerCase()
  // 兼容英文字段与中英文时段名
  if (lower.includes('deepvalley') || lower.includes('deep_valley') || lower.includes('deep-valley') || key.includes('深谷')) return 'deepValley'
  if (lower.includes('shrap') || lower.includes('sharp') || key.includes('尖峰')) return 'sharp'
  if (lower.includes('peak') || key.includes('高峰')) return 'peak'
  if (lower.includes('flat') || key.includes('平时段') || key.includes('平段')) return 'flat'
  if (lower.includes('valley') || key.includes('低谷')) return 'valley'

  key = key.replace(/^in/i, '').replace(/^out/i, '')
  key = key.replace(/price$/i, '')
  key = key.charAt(0).toLowerCase() + key.slice(1)
  if (key === 'deep') return 'deepValley'
  return key
}

function normalizeClockTime(raw) {
  if (raw === null || raw === undefined) return ''
  const text = String(raw).trim()
  if (!text) return ''
  if (text === '24:00' || text.endsWith(' 24:00:00') || text.endsWith('T24:00:00')) return '24:00'
  const match = text.match(/(\d{2}):(\d{2})/)
  if (!match) return ''
  return `${match[1]}:${match[2]}`
}

function buildGwPriceMap(operateType, tableData) {
  const map = {}
  if (operateType === 'GW_SAME' && Array.isArray(tableData)) {
    tableData.forEach((it) => {
      const k = normalizeGwSegmentKey(it.key || it.name)
      const rawVal = it?.value ?? it?.price ?? it?.inPrice ?? it?.chargePrice
      if (k) map[k] = +rawVal || 0
    })
  } else if (operateType === 'GW_DIFF' && Array.isArray(tableData?.in)) {
    tableData.in.forEach((it) => {
      const k = normalizeGwSegmentKey(it.key || it.name)
      const rawVal = it?.value ?? it?.price ?? it?.inPrice ?? it?.chargePrice
      if (k) map[k] = +rawVal || 0
    })
  }
  return map
}

function getGwTimelineSlotsFromOrigin() {
  const details = gwTimelineDetails.value?.length
    ? gwTimelineDetails.value
    : elecPanelData.originInfo?.priceDetails
  if (!Array.isArray(details) || !details.length) return []
  return details
    .map((it) => {
      const segmentKey = normalizeGwSegmentKey(it.name)
      const startTime = normalizeClockTime(it.startTime)
      const endTime = normalizeClockTime(it.endTime)
      const rawPrice = it?.chargePrice ?? it?.price ?? it?.inPrice ?? 0
      return {
        segmentKey,
        startTime,
        endTime,
        name: getElecPriceSegmentName(segmentKey),
        color: getElecPriceSegmentColor(segmentKey || 'flat'),
        originPrice: +rawPrice || 0,
      }
    })
    .filter((it) => it.segmentKey && it.startTime && it.endTime)
    .sort((a, b) => getMinutesCountByTime(a.startTime) - getMinutesCountByTime(b.startTime))
}

function buildGwFallbackRows(operateType, tableData) {
  const n = 5
  const slice = 1440 / n
  const rows = []
  const list = operateType === 'GW_SAME' ? tableData : tableData?.in
  if (!Array.isArray(list)) return rows
  list.forEach((it, i) => {
    const st = Math.round(i * slice)
    const et = i === n - 1 ? 1440 : Math.round((i + 1) * slice)
    const segmentKey = normalizeGwSegmentKey(it.key || it.name)
    rows.push({
      name: it.name || getElecPriceSegmentName(segmentKey),
      price: +it.value || 0,
      startTime: getTimeByMinutesCount(st),
      endTime: et >= 1440 ? '24:00' : getTimeByMinutesCount(et),
      color: it.color || getElecPriceSegmentColor(segmentKey || 'flat'),
    })
  })
  return rows
}

function buildGwBarPreviewRows(operateType, tableData) {
  const timelineSlots = getGwTimelineSlotsFromOrigin()
  const priceMap = buildGwPriceMap(operateType, tableData)
  if (timelineSlots.length && Object.keys(priceMap).length) {
    return timelineSlots.map((slot) => {
      const price = priceMap[slot.segmentKey]
      return {
        name: slot.name,
        price: Number.isFinite(price) ? price : slot.originPrice,
        startTime: slot.startTime,
        endTime: slot.endTime,
        color: slot.color,
      }
    })
  }
  return buildGwFallbackRows(operateType, tableData)
}

function buildCustomBarPreviewRows(operateType, tableData) {
  const rows = []
  if (operateType === 'CUSTOM_SAME' && Array.isArray(tableData)) {
    tableData.forEach((it) => {
      const startTime = normalizeClockTime(it.startTime)
      const endTime = normalizeClockTime(it.endTime)
      if (!it.key || !startTime || !endTime) return
      rows.push({
        name: getElecPriceSegmentName(it.key),
        price: +it.price || 0,
        startTime,
        endTime,
        color: getElecPriceSegmentColor(it.key),
      })
    })
  } else if (operateType === 'CUSTOM_DIFF' && Array.isArray(tableData)) {
    tableData.forEach((it) => {
      const startTime = normalizeClockTime(it.startTime)
      const endTime = normalizeClockTime(it.endTime)
      if (!it.key || !startTime || !endTime) return
      rows.push({
        name: getElecPriceSegmentName(it.key),
        price: +it.inPrice || 0,
        startTime,
        endTime,
        color: getElecPriceSegmentColor(it.key),
      })
    })
  }
  return rows
}

function modalChargeTypeForPreview() {
  if (formData.isUseGwPrice) return 2
  return formData.isInOutDiff ? 0 : 2
}

function updateModalPreview() {
  if (!showProxy.value) return
  if (priceMode.value === 'spot') {
    const key = spotActiveType.value === 'dayAhead' ? 'dayAhead' : 'realtime'
    const curve = spotCurves[key]
    const service = spotServiceFees[key]
    // 带上时间点：间隔不固定时，预览不能再按下标 × 15 分钟推算 x 轴位置
    previewLineValues.value = (spotSlots[key] || []).map((slot, i) => ({
      time: slot,
      value: (+curve[i] || 0) + (+service[i] || 0),
    }))
    return
  }
  // 优先实时读取子表单数据，避免使用旧缓存导致预览与左侧不一致
  const pf = (ElecPanel.value?.getPreviewData?.())
    || panelPreviewPayload.value
    || ElecPanel.value?.getCommitData?.()
  if (!pf) return
  const op = pf.operateType
  const td = pf.tableData
  let details = []
  if (op === 'GW_SAME' || op === 'GW_DIFF') {
    details = buildGwBarPreviewRows(op, td)
  } else {
    details = buildCustomBarPreviewRows(op, td)
    if (!details.length || details.some((d) => !d.startTime || !d.endTime)) {
      details = []
    }
  }
  previewBarPayload.value = {
    priceDetails: details,
    chargeType: modalChargeTypeForPreview(),
  }
}

function checkSpotPriceData() {
  if (!spotDate.value) {
    window.dispatchNotify({ type: 'warning', message: '请选择现货日期。' })
    return false
  }
  const key = spotActiveType.value === 'dayAhead' ? 'dayAhead' : 'realtime'
  const values = spotCurves[key]
  const services = spotServiceFees[key]
  const count = spotSlots[key]?.length || 0
  if (!count || !Array.isArray(values) || values.length !== count) {
    window.dispatchNotify({ type: 'warning', message: '现货曲线数据异常。' })
    return false
  }
  const bad = values.some((v) => v === null || v === '' || isNaN(+v))
    || !Array.isArray(services)
    || services.length !== count
    || services.some((v) => v === null || v === '' || isNaN(+v) || +v < 0)
  if (bad) {
    window.dispatchNotify({
      type: 'warning',
      message: `请填写完整的 ${count} 个现货电价（可为负数）与服务费（非负数字）。`
    })
    return false
  }
  return true
}

async function saveSpotSnapshotData() {
  const areaCode = await resolveSpotAreaCode()
  if (!spotDate.value || !stationId.value) {
    window.dispatchNotify({ type: 'warning', message: '现货快照保存缺少必要参数。' })
    return false
  }
  const key = spotActiveType.value === 'dayAhead' ? 'dayAhead' : 'realtime'
  const values = spotCurves[key]
  const services = spotServiceFees[key]
  const snapshots = spotRows.value.map((row) => ({
    timeSlot: row.startTime,
    marketPrice: Number((+values[row.index] || 0).toFixed(6)),
    servicePrice: Number((+services[row.index] || 0).toFixed(6)),
    sourceType: 2,
  }))
  const payload = {
    priceDate: spotDate.value,
    priceType: Number(toSpotApiPriceType()),
    stationId: Number(stationId.value),
    snapshots,
  }
  const areaName = resolveSpotAreaName()
  if (areaCode) payload.areaCode = areaCode
  if (areaName) payload.areaName = areaName
  try {
    await batchSaveSpotSnapshot(payload)
    return true
  } catch (e) {
    window.dispatchNotify({ type: 'warning', message: '现货快照保存失败，请稍后重试。' })
    return false
  }
}

function buildRemarkForSubmit() {
  if (priceMode.value === 'spot') {
    return 'spot'
  }
  if (priceMode.value === 'chargingPile') {
    return JSON.stringify({ entryMode: 'chargingPile' })
  }
  return ''
}

/** 校验：时间范围 */
function checkDateRange(apiParams, data) {
  if (Array.isArray(data) && data.length === 2) {
    apiParams['startDate'] = dayjs(data[0]).format('YYYY-MM-DD');
    apiParams['endDate'] = dayjs(data[1]).format('YYYY-MM-DD');
    return true;
  } else {
    return false;
  }
}

/** 校验：时段名称 */
function checkSigmentName(type, data) {
  let isOk = true;
  if (type === 'CUSTOM_SAME' || type === 'CUSTOM_DIFF') {
    isOk = false;
    if (Array.isArray(data)) {
      isOk = data.every(it => it.key);
    }
  }
  return isOk;
}

/** 校验：存在时间范围重叠 */
async function checkExistOverlap(dateRange, operateType, elecPriceId) {
  const params = {
    stationId: stationId.value,
    startDate: dayjs(dateRange[0]).format('YYYY-MM-DD'),
    endDate: dayjs(dateRange[1]).format('YYYY-MM-DD'),
  }
  // 只有编辑时，需要传递电价ID，作用：查覆盖时排除自己
  if (operateType === 'edit') {
    params['elecPriceId'] = elecPriceId;
  }
  const isOverlap = await queryDateRangeIsOverlap(params).then(res => res.data);
  if (isOverlap) {
    const userAgree = await ElMessageBox.confirm($str.getKey('收益管理/此时间段已存在电价，覆盖会影响对应的收益计算，确认是否覆盖？'), $str.getKey('收益管理/系统提示'), {
      confirmButtonText: $str.getKey('收益管理/确定'),
      cancelButtonText: $str.getKey('收益管理/取消'),
      "show-close": false,
      type: "warning"
    }).then(res => {
      return true;
    }).catch(err => {
      return false
    });

    if (userAgree) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

/** 校验：电价数据 */
function checkPriceListData(apiParams, type, data, demandPrice = 0) {
  if (type === 'GW_SAME') {
    if (Array.isArray(data)) {
      const isNg = data.some(it => ( it.value === null || isNaN(+it.value))); // 电价值中，是否存在非数值的数据
      if (isNg) {
        return false;
      } else {
        const basePrice = {
          demandPrice: Number((+demandPrice).toFixed(6)),
        };
        data.forEach(it => {
          const inKey = 'in' + it.key.charAt(0).toUpperCase() + it.key.slice(1);
          basePrice[inKey] = (+it.value).toFixed(6); // 保留6位小数
          const outKey = 'out' + it.key.charAt(0).toUpperCase() + it.key.slice(1);
          basePrice[outKey] = (+it.value).toFixed(6); // 保留6位小数
        })
        apiParams['basePrice'] = basePrice;
        return true;
      }
    } else {
      return false;
    }
  }

  if (type === 'GW_DIFF') {
    if (Array.isArray(data.in) && Array.isArray(data.out)) {
      const itemList = [...data.in, ...data.out]
      const isNg = itemList.some(it => ( it.value === null || isNaN(+it.value))); // 电价值中，是否存在非数值的数据
      if (isNg) {
        return false;
      } else {
        const basePrice = {
          demandPrice: Number((+demandPrice).toFixed(6)),
        };

        itemList.forEach(it => {
          basePrice[it.key] = (+it.value).toFixed(6); // 保留6位小数
        })
        apiParams['basePrice'] = basePrice;

        return true;
      }
    } else {
      return false;
    }

  }

  if (type === 'CUSTOM_SAME') {
    if (Array.isArray(data)) {
      // 检查时间：必填 && 必须正向连续覆盖00:00~23:59
      let isOk = checkTimeRange(data);
      if (!isOk) {
        return false;
      }

      // 检查时段电价值:
      let isNg = data.some(it => ( it.price === null || isNaN(+it.price)));
      if (isNg) {
        window.dispatchNotify({
          type: "warning",
          message: $str.getKey('收益管理/【电价】必须为非空数值！')
        });
        return false;
      } else {
        const customPrice = {
          demandPrice: Number((+demandPrice).toFixed(6)),
          startDate: apiParams.startDate,
          endDate: apiParams.endDate,
          priceDetails: [],
        };
        data.forEach(it => {
          const detailItem = {
            name: it.key,
            startTime: it.startTime,
            endTime: it.endTime,
            chargePrice: it.price.toFixed(6), // 保留6位小数,
            dischargePrice: it.price.toFixed(6), // 保留6位小数, 
          }
          customPrice.priceDetails.push(detailItem);
        })
        apiParams['customPrice'] = customPrice;

        return true;
      }

    } else {
      return false;
    }
  }

  if (type === 'CUSTOM_DIFF') {
    if (Array.isArray(data)) {
      // 检查时间：必填 && 必须正向连续覆盖00:00~23:59
      let isOk = checkTimeRange(data);
      if (!isOk) {
        return false;
      }

      // 检查时段电价值:
      let isNg = data.some(it => ( it.inPrice === null || isNaN(+it.inPrice) || it.outPrice === null || isNaN(+it.outPrice)));
      if (isNg) {
        window.dispatchNotify({
          type: "warning",
          message: $str.getKey('收益管理/【电价】必须为非空数值！')
        });
        return false;
      } else {
        const customPrice = {
          demandPrice: Number((+demandPrice).toFixed(6)),
          startDate: apiParams.startDate,
          endDate: apiParams.endDate,
          priceDetails: [],
        };
        data.forEach(it => {
          const detailItem = {
            name: it.key,
            startTime: it.startTime,
            endTime: it.endTime,
            chargePrice: it.inPrice.toFixed(6), // 保留6位小数,
            dischargePrice: it.outPrice.toFixed(6), // 保留6位小数, 
          }
          customPrice.priceDetails.push(detailItem);
        })
        apiParams['customPrice'] = customPrice;

        return true;
      }

    } else {
      return false;
    }
  }


  return false;
}

/** 校验：电价名称 */
async function checkElecPriceName(apiParams, data) {
  if (data) {
    apiParams['priceName'] = data;
    return true;
  } else {
    const userAgree = await ElMessageBox.confirm($str.getKey('收益管理/未填写电价名称，系统将自动为您生成电价名称'), $str.getKey('收益管理/系统提示'), {
      confirmButtonText: $str.getKey('收益管理/确定'),
      cancelButtonText: $str.getKey('收益管理/取消'),
      "show-close": false,
      type: "warning"
    }).then(res => {
      return true;
    }).catch(err => {
      return false
    });

    if (userAgree) {
      return true;
    } else {
      return false;
    }
  }
}

/**
 * 检查时间范围：
 * >>> 连续覆盖 00:00~23:59 且 不能出现时间上的重叠
 * >>> 每个时段的 startTime < endTime
 * @param {Array} data 
 * @returns 
 */
function checkTimeRange(data) {
  if (Array.isArray(data)) {
    let isNg = data.some(it => !it.startTime || !it.endTime);
    if (isNg) {
      window.dispatchNotify({
        type: "warning",
        message: $str.getKey('收益管理/【开始时间】和【结束时间】不能为空！')
      });
      return !isNg;
    }

    isNg = data.some(it => !(dayjs(it.startTime, 'HH:mm').isBefore(dayjs(it.endTime, 'HH:mm'))));
    if (isNg) {
      window.dispatchNotify({
        type: "warning",
        message: $str.getKey('收益管理/每项的【结束时间】必须大于【开始时间】！')
      });
      return !isNg;
    }

    const timeList = data.map(it => {
      return [it.startTime, it.endTime]
    }).sort((a,b) => {
      return dayjs(a[0], 'HH:mm').isBefore(dayjs(b[0], 'HH:mm')) ? -1 : 1;
    })
    const len = timeList.length;
    isNg = timeList.some((it, idx) => {
      // 是否从00:00开始
      if (idx === 0 && it[0] !== '00:00') {
        return true;
      }

      // 时段之间是否连续
      if (idx < len -1 && !(dayjs(timeList[idx][1], 'HH:mm').isSame(dayjs(timeList[idx + 1][0], 'HH:mm'), 'minute'))) {
        return true;
      }
      
      // 是否以23:59结束
      if (idx === len - 1 && it[1] !== '23:59') {
        return true;
      }

      return false;
    })
    if (isNg) {
      window.dispatchNotify({
        type: "warning",
        message: $str.getKey('收益管理/电价时段必须连续覆盖0~24时！')
      });
      return !isNg;
    }

    return true;
  } else {
    console.error('调用 checkTimeRange 方法时，参数必须为数组格式！');
    return false;
  }
}






</script>

<style lang="scss" scoped>
.modal-container {
  // 弹窗背景色与系统主页面保持一致
  :deep(.el-dialog) {
    border-radius: 30px !important;
    background: linear-gradient(180deg, #F6FBFF 0%, #FFF 100%) !important;
    background-color: transparent !important;
    overflow: hidden;
    max-width: 1200px !important;
  }

  :deep(.el-dialog__header) {
    background: transparent !important;
    background-color: transparent !important;
    border-bottom: none;
  }

  :deep(.el-dialog__body) {
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
  }

  :deep(.el-dialog__footer) {
    background: transparent !important;
    background-color: transparent !important;
    border-top: none;
  }

  .footer-container {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-right: 20px;
    
    :deep(.el-button) {
      border-radius: 999px !important;
    }
    
    :deep(.el-button--primary) {
      border-radius: 999px !important;
    }
    
    // 确定按钮样式
    :deep(.confirm-btn) {
      display: flex !important;
      width: 130px !important;
      height: 37px !important;
      padding: 10px 8px !important;
      justify-content: center !important;
      align-items: center !important;
      gap: 10px !important;
      color: #ffffff !important;
      
      span {
        color: #ffffff !important;
      }
    }
    
    // 取消按钮样式
    :deep(.cancel-btn) {
      display: flex !important;
      width: 130px !important;
      height: 37px !important;
      padding: 10px 8px !important;
      justify-content: center !important;
      align-items: center !important;
      gap: 10px !important;
    }
  }

  .header-container {
    & {
      height: 35px;
      padding: 20px;
      padding-bottom: 0;
      display: flex;
      align-items: center;
      background: transparent;
    }

    .icon-container {
      width: 29px;
      height: 29px;
      background-image: radial-gradient(#FFF 5%, #3a68ff 30%);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #3a68ff;
      transform: rotate(45deg);
      margin-right: 20px;
    }

    .title-text {
      color: #2E2E2E;
      font-family: "HarmonyOS Sans SC";
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .content-container {
    & {
      width: 100%;
      height: 70vh;
      box-sizing: border-box;
      padding: 20px;
      overflow: scroll;
      display: flex;
      flex-direction: column;
      gap: 20px;
      background: transparent;

      // 信息面板header的通用样式
      .info-panel-header {
        display: flex;
        align-items: center;
        gap: 10px;
        .header-icon-container {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #394155;
          display: flex;
          justify-content: center;
          align-items: center;
          .header-icon {
            width: 20px;
            height: 20px;
          }
        }
        .header-name {
          margin: 0 4px;
          color: #2E2E2E;
          font-family: "HarmonyOS Sans SC";
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        .time-selecte-container {
          ::v-deep .el-date-editor--month {
            width: 160px;
            
            .el-input__wrapper {
              border-radius: 999px !important;
            }
          }
        }
        .header-refinfo {
          color: #2E2E2E;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: "HarmonyOS Sans SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }

    &.spot-mode-content {
      overflow: hidden;
      .spot-preview-row {
        flex: 1;
        min-height: 0;
        height: auto;
      }
      .spot-section,
      .preview-chart-section {
        min-height: 0;
      }
    }

    .meter-info-container {
      width: 100%;
      flex-shrink: 0;
      // margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .range-table-container {
        width: 100%;
        .table-content {
          width: 100%;
          border: 1px solid #3B465E;
          display: flex;
          justify-content: space-between;

          .range-item {
            width: 100%;
            .header-cell, .body-cell {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              &.header-cell {
                height: 32px;
                background: #2C3548;
              }
              &.body-cell {
                min-height: 32px;
              }
            }
          }
        }
      }
    }

    .config-info-container {
      width: 100%;
      height: 400px;
      flex-shrink: 0;
      margin: 0;
      display: flex;
      gap: 20px;

      .left-container {
        & {
          width: 100%;
          height: 100%;
          border-radius: 12px;
          background: #ffffff;
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
        }

        .price-img-container {
          width: 100%;
          height: 100%;
          flex: 1;
          overflow: hidden;
          .price-img {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .img {
              max-height: 100%;
              object-fit: scale-down; // 选择 none 或 contain 中较小的一个
            }
          }
          .no-pic {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 180px;
            }
            .tip-text {
              color: #B1BCD6;
              font-size: 12px;
              position: relative;
              top: -40px;
            }
          }
        }
      }
    }

    .price-mode-section {
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 16px 20px;
      border-radius: 12px;
      background: #ffffff;
      box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
      flex-shrink: 0;
      .mode-title {
        font-size: 14px;
        color: #2e2e2e;
        font-weight: 500;
      }
      .mode-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 18px;
      }
      :deep(.el-radio) {
        margin-right: 0;
      }
      :deep(.el-radio__label) {
        color: #2e2e2e;
      }
      :deep(.el-radio__input.is-checked + .el-radio__label) {
        color: #1862f5;
      }
    }

    .info-preview-row,
    .spot-preview-row {
      width: 100%;
      display: flex;
      gap: 20px;
      align-items: stretch;
      flex-shrink: 0;
      height: 560px;
      min-height: 560px;
    }

    .spot-preview-row {
      height: auto;
      min-height: 0;
    }

    .spot-section {
      flex: 1;
      min-width: 0;
      height: 100%;
      border-radius: 12px;
      background: #ffffff;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
      display: flex;
      flex-direction: column;
      .spot-toolbar {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
        margin: 12px 0;
        flex-shrink: 0;
        .spot-date-picker {
          width: 170px;
        }
        .spot-actions {
          display: flex;
          gap: 8px;
          margin-left: auto;
        }
      }
      .hidden-file-input {
        display: none;
      }
      .spot-table-scroll {
        overflow: auto;
        max-width: 100%;
        border-radius: 8px;
        border: 1px solid #edf2f6;
        flex: 1;
        min-height: 0;
        max-height: 100%;
      }
      .spot-grid {
        width: 100%;
        border-collapse: collapse;
        font-size: 11px;
        th,
        td {
          border: 1px solid #edf2f6;
          padding: 4px 4px;
          text-align: center;
        }
        .spot-corner,
        .spot-row-title {
          background: #f6fbff;
          font-weight: 500;
          position: sticky;
          left: 0;
          z-index: 1;
        }
        .spot-value-cell {
          min-width: 68px;
        }
        .spot-readonly {
          display: inline-block;
          min-width: 52px;
        }
      }
      .vertical-grid {
        th, td {
          white-space: nowrap;
        }
        th {
          background: #f6fbff;
          position: sticky;
          top: 0;
          z-index: 2;
        }
        td:nth-child(2),
        th:nth-child(2) {
          min-width: 100px;
        }
      }
    }

    .preview-chart-section {
      width: 40%;
      min-width: 300px;
      height: 100%;
      border-radius: 12px;
      background: #ffffff;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
      display: flex;
      flex-direction: column;
      .preview-chart-body {
        padding: 8px 0 0;
        flex: 1;
      }
    }

    .price-info-container {
      & {
        width: 60%;
        min-width: 0;
        min-height: 420px;
        height: 100%;
        border-radius: 12px;
        background: #ffffff;
        flex-shrink: 0;
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
      }

      .price-form-panel {
        width: 100%;
        // height: 100%;
        padding: 10px 40px;
        flex: 1;
        min-height: 0;
        overflow: auto;
        // background: lime;
        
        .header-form {
          .date-range-container {
            display: flex;
            align-items: center;
            gap: 10px;
            .tip-info {
              color: #B1BCD6;
              font-size: 12px;
              display: flex;
              align-items: center;
              gap: 6px;
            }
          }
        }
      }

      .inout-diff-block {
        flex-shrink: 0;
        padding: 4px 40px 12px;
        border-top: 1px solid #edf2f6;
        margin-top: 4px;
      }
      .inout-diff-row {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 12px;
      }
      .inout-diff-name {
        font-size: 14px;
        color: #2e2e2e;
      }
      .inout-diff-switch {
        margin-left: auto;
        --el-switch-on-color: #00dd7a;
        flex-shrink: 0;
      }
      .inout-diff-tip {
        display: flex;
        align-items: flex-start;
        gap: 6px;
        margin-top: 8px;
        color: rgba(46, 46, 46, 0.5);
        font-size: 12px;
        line-height: normal;
      }
    }

  }
}
</style>

<style lang="scss">
// 全局样式确保弹窗背景渐变生效（不使用 scoped）
.el-dialog.modal-container {
  background: linear-gradient(180deg, #F6FBFF 0%, #FFF 100%) !important;
  border-radius: 30px !important;
  overflow: hidden !important;
}

.el-dialog.modal-container .el-dialog__header,
.el-dialog.modal-container .el-dialog__body,
.el-dialog.modal-container .el-dialog__footer {
  background: transparent !important;
}
</style>
